import {
  deleteServiceNodeConfigDtlById,
  findServiceNodeConfigById,
  findServiceNodeConfigDtl,
  sortNumServiceNodeConfigDtl,
} from '@/services/serviceConfig'
import { useRequest } from 'ahooks'
import { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { useParams } from 'react-router'
import { SActionBtn, SBack, SGeneralForms, SMessage, STableActions, STitle } from 'shj-components'
import React from 'react'
import { Button, Card, RowProps, Table, TableColumnsType, Tooltip, message } from 'antd'
import { addFn } from './addAndEdit'
import { authDict } from 'shj-utils'
import { HolderOutlined, NotificationOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { DndContext } from '@dnd-kit/core'
import {
  SortableContext,
  arrayMove,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { DragEndEvent } from '@dnd-kit/core'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { CSS } from '@dnd-kit/utilities'
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities'

export const CustomerConfigDetail: React.FC<any> = props => {
  const { id } = useParams()
  const formRefs = useRef<any>()
  let { data: pageData = {}, runAsync } = useRequest<any, any>(findServiceNodeConfigById, {
    manual: true,
  })
  const [dataSource, setDataSource] = useState([])
  const RowContext = React.createContext<RowContextProps>({})
  const DragHandle: React.FC = () => {
    const { setActivatorNodeRef, listeners } = useContext(RowContext)
    return (
      <Button
        type="text"
        size="small"
        icon={<HolderOutlined />}
        style={{ cursor: 'move' }}
        ref={setActivatorNodeRef}
        {...listeners}
      />
    )
  }
  useEffect(() => {
    getDetail()
  }, [])

  const getDetail = () => {
    runAsync(id, { params: { labelFlag: true } })
    findServiceNodeConfigDtl({ serviceNodeId: id }).then(res => {
      res.map((item, index) => (item.key = index + 1))
      setDataSource(res)
    })
  }
  const onDelete = nodeId => {
    const dialog = SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteServiceNodeConfigDtlById(nodeId)
          if (res.errorCode === 0) {
            message.success('删除成功')
            findServiceNodeConfigDtl({ serviceNodeId: id }).then(res => {
              res.map((item, index) => (item.key = index + 1))
              setDataSource(res)
            })
          } else {
            message.error('删除失败')
          }
        } catch (err) {
          console.log(err)
        }
        dialog?.destroy()
      },
      onCancel: () => {
        message.warning('取消删除')
        dialog?.destroy()
      },
    })
  }

  interface RowContextProps {
    setActivatorNodeRef?: (element: HTMLElement | null) => void
    listeners?: SyntheticListenerMap
  }

  const Row: React.FC<RowProps> = props => {
    const {
      attributes,
      listeners,
      setNodeRef,
      setActivatorNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: props['data-row-key'] })

    const style: React.CSSProperties = {
      ...props.style,
      transform: CSS.Translate.toString(transform),
      transition,
      ...(isDragging ? { position: 'relative', zIndex: 1 } : {}),
    }

    const contextValue = useMemo<RowContextProps>(
      () => ({ setActivatorNodeRef, listeners }),
      [setActivatorNodeRef, listeners]
    )

    return (
      <RowContext.Provider value={contextValue}>
        <tr {...props} ref={setNodeRef} style={style} {...attributes} />
      </RowContext.Provider>
    )
  }
  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      setDataSource(prevState => {
        const activeIndex = prevState.findIndex((record: any) => record.key === active?.id)
        const overIndex = prevState.findIndex((record: any) => record.key === over?.id)
        const newDataSource = arrayMove(prevState, activeIndex, overIndex)
        saveNewOrder(newDataSource)
        return newDataSource
      })
    }
  }
  const saveNewOrder = newDataSource => {
    sortNumServiceNodeConfigDtl(newDataSource.map(item => item.id)).then(() => {
      message.success('排序已保存')
    })
  }
  const handleRender = (text, record) => {
    return (
      <STableActions>
        <SActionBtn
          onClick={() => {
            addModel(record.id)
          }}
          auth={'customerNodeListEdit'}
        >
          编辑
        </SActionBtn>
        <SActionBtn danger auth={'customerNodeListDel'} onClick={() => onDelete(record.id)}>
          删除
        </SActionBtn>
      </STableActions>
    )
  }
  const nodeTypeRender = (text, record) => {
    return (
      <>
        {text}&nbsp;
        {record.nodeType === 'serviceMsg' ? (
          <Tooltip placement="bottom" title={record.msgModel}>
            <NotificationOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          </Tooltip>
        ) : (
          ''
        )}
      </>
    )
  }
  const addModel = nodeId => {
    addFn({
      serviceNodeId: id,
      id: nodeId,
      fn: () => {
        findServiceNodeConfigDtl({ serviceNodeId: id }).then(res => {
          res.map((item, index) => (item.key = index + 1))
          setDataSource(res)
        })
      },
    })
  }
  const columns: TableColumnsType<any> = [
    { key: 'sort', title: '排序', dataIndex: 'index', render: () => <DragHandle /> },
    {
      title: '节点名称',
      dataIndex: 'nodeName',
      ellipsis: { showTitle: false },
      render: text => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    { title: '节点类型', dataIndex: 'typeName' },
    {
      title: '产品分类',
      dataIndex: 'prodCatNames',
      ellipsis: { showTitle: false },
      render: text => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    {
      title: (
        <>
          生成方式{' '}
          <Tooltip
            placement="bottom"
            title="按需：根据客户购买产品生成确认节点。固定：每个产品在服务过程中固定生成需要客户确定节点"
          >
            <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          </Tooltip>
        </>
      ),
      dataIndex: 'createTypeName',
    },
    {
      title: (
        <>
          节点方式{' '}
          <Tooltip
            placement="bottom"
            title="确认：节点提交验收后需要客户确认通过该节点才算完成，通知：节点提交验收后节点完成，并给客户发送通知消息"
          >
            <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          </Tooltip>
        </>
      ),
      dataIndex: 'nodeTypeName',
      render: (text, record) => nodeTypeRender(text, record),
    },
    {
      title: '说明',
      dataIndex: 'remarks',
      ellipsis: { showTitle: false },
      render: text => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    {
      title: '服务标准',
      dataIndex: 'acceptanceCriteria',
      ellipsis: { showTitle: false },
      render: text => (
        <Tooltip placement="topLeft" title={text}>
          {text}
        </Tooltip>
      ),
    },
    { title: '状态', dataIndex: 'status', render: (status: boolean) => (status ? '启用' : '禁用') },
    { title: '操作', dataIndex: 'handle', render: (text, record) => handleRender(text, record) },
  ]
  return (
    <SBack title={'客户服务详情'} level={2}>
      <Card bordered={false} style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
        <SGeneralForms
          ref={formRefs}
          detailsData={pageData}
          isDetail={true}
          configs={[
            {
              title: '信息',
              titleMode: 'drawer',
              formItem: [
                {
                  name: 'code',
                  label: '服务编码',
                },
                {
                  name: 'companyName',
                  label: '适用门店',
                },
                {
                  name: 'prodLabNames',
                  label: '需求标签',
                },
                {
                  name: 'name',
                  label: '服务名称',
                },
                {
                  name: 'remarks',
                  label: '服务标准',
                  spanCol: 24,
                  children: <div style={{ color: 'rgb(102, 102, 102)' }}>{pageData.remarks}</div>,
                },
              ],
            },
          ]}
        />
        <STitle
          title={
            <div
              style={{
                fontWeight: 400,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '12px',
              }}
            >
              服务节点
              {authDict['customerNodeListAdd'] ? (
                <Button
                  type="primary"
                  onClick={() => {
                    addModel('')
                  }}
                >
                  新增
                </Button>
              ) : null}
            </div>
          }
        />
        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
          <SortableContext
            items={dataSource.map((i: any) => i.key)}
            strategy={verticalListSortingStrategy}
          >
            <Table
              rowKey="key"
              components={{ body: { row: Row } }}
              columns={columns}
              dataSource={dataSource}
              pagination={false}
            />
          </SortableContext>
        </DndContext>
      </Card>
    </SBack>
  )
}
export default CustomerConfigDetail
